import config from "./config/config";
import createAuthedClient from "./api/createAuthedClient";

const api = createAuthedClient(config.BASE_PATH);

export default api;
